var path = 'src/app/forms/fields/observation-field.html';
var html = "<div observation-selector frm-model frm-required patient=patient ng-model=model ng-required=required()></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/observation-field.html
 ** module id = 282
 ** module chunks = 0
 **/